import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountry extends TitleBase {
	private countryValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);

		return this.indexableFilters.length >= 1 && this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.titlePortalType, ` in ${this.countryValue}`);
	}
}
